import {
  AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent,
  AlertDialogHeader, AlertDialogOverlay, Button, Flex, Input, Stack, Text
} from "@chakra-ui/react";
import { Preview } from "components/add-people";
import { ModalInfoIcon } from "components/popups/ModalInfoIcon";
import { useSession } from "next-auth/react";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { textStyle } from "theme/names";
import { getAccount, updateUser } from "utils/sessionHelper";
import { useFirebaseUser } from "utils/useFirebaseUser";

export function CreateEditList({
  onClose,
  isOpen,
  lists = [],
  onCreation,
  mode = "",
  selectedListId = undefined,
  contacts = []
}) {
  const [listName, setListName] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const cancelRef = useRef(null);
  const { data: session } = useSession() ?? {}
  const isAuthenticated = useFirebaseUser();

  const makeList = async () => {
    try {
      if (!isAuthenticated) {
        toast.error("User is not authenticated to create list");
        return;
      }
      if (!listName) {
        toast.error("Enter a valid list name");
        return;
      }
      setIsLoading(true);

      let contactLists = [...lists];
      let nextId

      if (mode === "edit") {
        // @ts-ignore
        const index = [...lists].findIndex((x) => x.id === selectedListId);
        // @ts-ignore
        contactLists[index].name = listName;
      } else {
        nextId =
          getAccount(session).contactLists &&
          getAccount(session).contactLists?.length > 0
            ? Math.max(...getAccount(session).contactLists.map((x) => x.id)) + 1
            : 0;
        // @ts-ignore
        contactLists.push({ name: listName, id: nextId, createdAt: new Date() });
      }

      await updateUser(session, { contactLists });

      if (mode === "edit") {
        toast.success("Updated successfully");
      } else {
        toast.success(`Successfully created ${listName}`);
      }

      await onCreation(nextId);
      setListName("");
    } catch (err) {
      console.log("Error in creating list: ", err);
      toast.error("Error in creating list: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit") {
      // @ts-ignore
      const list: any = lists.find((x) => x.id === selectedListId);
      setListName(list?.name);
    } else {
      setListName("");
    }
  }, [mode, selectedListId]);

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
    >
      <AlertDialogOverlay />

      <AlertDialogContent py="3">
        <AlertDialogHeader
        // fontWeight="bold" pb="0"
        >
          {/* <ModalInfoIcon /> */}
          {mode === "edit" ? "Update list name" : "Create a new list"}
        </AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody pt="0" mb="6">
          {mode === "existing" ? (
            <Stack>
              <Text textStyle={textStyle["body.medium.light"]} fontSize="sm">with contacts:</Text>
              <Preview people={contacts} align="start" noOfImagePreview={5} />
            </Stack>
          ) : !mode ? (
            <Text textStyle={textStyle["body.medium.light"]} color="gray" as="i" fontSize="sm">
              You'll be able to add people at the next step.
            </Text>
          ) : null}
          <Flex mt="5" justifyContent="space-between">
            <Input
              value={listName}
              placeholder="List name"
              maxWidth="70%"
              onChange={(e) => setListName(e.target.value)}
              isDisabled={isLoading}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  makeList();
                }
              }}
            />
            <Button
              // colorScheme="blue"
              // bg="blue.700"
              // color="white"
              // _hover={{ bg: "blue.600" }}
              variant={"primary"}
              onClick={makeList}
              isLoading={isLoading}
            >
              {mode === "edit" ? "Update" : "Create List"}
            </Button>
          </Flex>
        </AlertDialogBody>
        {/* {!editMode && (
          <AlertDialogFooter fontSize="xs" as="i" color="gray">
            Note: when you create a list, we create an equivalent private list
            on Twitter for you. People will not be notified that they are part
            of your list. If at any point you want that list deleted
            permanently, please delete it from Tweet Hunter.
          </AlertDialogFooter>
        )} */}
      </AlertDialogContent>
    </AlertDialog>
  );
}
